import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listPlans } from "../api/postPlansApi";
import {
  Box, Button, Typography, Paper, Stack, Divider, CircularProgress
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export default function PlansListPage() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();

  const token = null; // TODO: prendi token dal tuo store

  useEffect(() => {
    (async () => {
      try {
        const data = await listPlans(token);
        setPlans(data.plans || data || []);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <Box p={3}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5">Piani di Post</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate("/piani/new")}>
          Crea Piano Post
        </Button>
      </Stack>
      <Paper variant="outlined">
        {loading ? (
          <Box p={3} display="flex" justifyContent="center"><CircularProgress /></Box>
        ) : error ? (
          <Box p={3} color="error.main">{error}</Box>
        ) : plans.length === 0 ? (
          <Box p={3}>Nessun piano. Clicca “Crea Piano Post”.</Box>
        ) : (
          <Box>
            {plans.map((p, idx) => (
              <React.Fragment key={p.id || idx}>
                <Box p={2} display="flex" alignItems="center" justifyContent="space-between">
                  <Box>
                    <Typography variant="subtitle1" fontWeight={700}>{p.name}</Typography>
                    <Typography variant="body2" color="text.secondary">
                      Stato: {p.status || "draft"} • Versione: {p.version || 1}
                    </Typography>
                  </Box>
                  <Stack direction="row" spacing={1}>
                    <Button size="small" variant="outlined" onClick={() => navigate(`/piani/${p.id}/editor`)}>Apri</Button>
                    <Button size="small" onClick={() => navigate(`/piani/${p.id}/timeline`)}>Timeline</Button>
                  </Stack>
                </Box>
                <Divider />
              </React.Fragment>
            ))}
          </Box>
        )}
      </Paper>
    </Box>
  );
}
